import React from "react";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { NumericInput } from "@/components/inputs";

/**
 * RefinanceFields — conditional fields shown when loan type is Refinance.
 *
 * Renders the Cash-Out Amount input for refinance deals.
 */
export default function RefinanceFields({ scope }) {
  const { control, formState: { errors } } = useFormContext();
  const stepErrors = errors?.[scope];

  return (
    <div className="col-span-2 sm:col-span-1">
      <Controller
        name={`${scope}.cashOutAmount`}
        control={control}
        render={({ field }) => (
          <NumericInput
            placeholder="Cash-Out Amount (if any)"
            value={field.value}
            onChange={field.onChange}
            format="c0"
            currency="USD"
            min={0}
            error={stepErrors?.cashOutAmount?.message}
          />
        )}
      />
    </div>
  );
}

RefinanceFields.propTypes = {
  scope: PropTypes.string.isRequired,
};

